import QuestsPage from "./QuestsPage";

export default QuestsPage;
